export default __webpack_public_path__ + "833a0fd3b3e6b737f59969c8ae1545be.jpg";